const initialState = {
  pendingRequests: 0,
};

export default function globalLoaderReducer(state = initialState, action) {
  switch (action.type) {
    case "GLOBAL_LOADER/INCREMENT":
      return { ...state, pendingRequests: state.pendingRequests + 1 };
    case "GLOBAL_LOADER/DECREMENT":
      return { ...state, pendingRequests: Math.max(0, state.pendingRequests - 1) };
    case "GLOBAL_LOADER/RESET":
      return { ...state, pendingRequests: 0 };
    default:
      return state;
  }
}

